import { ActionCardModel } from '@playbooks/action-cards-utils/src'

export default class ActionCardReplacementsProcessor {
  actionCardModel: ActionCardModel

  constructor(actionCardModel: ActionCardModel) {
    this.actionCardModel = actionCardModel
  }

  process(template: string) {
    if (!this.actionCardModel?.replacementProcessor) {
      return template
    }
    return this.actionCardModel.replacementProcessor.processReplacements(template)
  }
}
